// ©2024 Austin App House. All rights reserved.
import React from 'react';
import DashboardIcon from '../../dashboard/icons/DashboardIcon';

const CreateDocumentForm = ({
  name,
  handlerCreate,
}) => (
  <form onSubmit={handlerCreate} className="project-company-control-add">
    <div className="field_col">
      <label className="field_name" htmlFor="project-company-document-name">
        {name}
        {' '}
        name
      </label>
      <div className="project-company-control-add__row">
        <div className="field_block">
          <input
            id="project-company-document-name"
            type="text"
            className="dashboard-input"
            placeholder={`${name} Name`}
            name="documentName"
          />
        </div>
        <button
          aria-label="Add"
          className="dashboard-btn dashboard-btn--primary"
          type="submit"
        >
          <DashboardIcon name="plus" size={16} strokeWidth="2.5" />
          Add
        </button>
      </div>
    </div>
  </form>
);

export default CreateDocumentForm;
